<script lang="ts">
  import { createEventDispatcher } from 'svelte';

  export let videoControls = false;
  export let videoElement: HTMLVideoElement | null = null;
  export let src: string;
  export let type: string | null | undefined = undefined;
  export let captionsSrc: string | undefined = undefined;

  const dispatch = createEventDispatcher<{ onLoad: void }>();

  let controlsTimeout: ReturnType<typeof setTimeout> | null = null;

  function handleMouseEnter() {
    videoControls = true;
  }

  function handleMouseLeave() {
    videoControls = false;
  }

  function handleTouchStart() {
    videoControls = true;

    if (controlsTimeout) {
      clearTimeout(controlsTimeout);
    }
    controlsTimeout = setTimeout(() => {
      videoControls = false;
    }, 3000);
  }

  function handleLoaded() {
    dispatch('onLoad');
  }
</script>

<video
  class="h-full w-full"
  loop
  controls="{videoControls}"
  muted
  playsinline
  autoplay
  bind:this="{videoElement}"
  on:loadedmetadata="{handleLoaded}"
  on:loadeddata="{handleLoaded}"
  on:canplaythrough="{handleLoaded}"
  on:mouseenter="{handleMouseEnter}"
  on:mouseleave="{handleMouseLeave}"
  on:touchstart="{handleTouchStart}"
>
  <source {src} {type} />

  {#if captionsSrc}
    <track default kind="captions" src="{captionsSrc}" />
  {/if}
</video>
